// @utilities
const { APIGet } = require('utilities/APIRequestHelper');
// @ constants
const actionTypes = require('constants/actionTypes');

function reset() {
    return {
        type: actionTypes.OPEN_YOUNG_INTERVENERS_RESET
    };
}

const changeIntervenerRelationship = (index, relationship) => ({
    type: actionTypes.OPEN_YOUNG_INTERVENERS_UPDATE_RELATIONSHIP,
    payload: {
        index,
        relationship
    }
});

const excludeIntervener = index => ({
    type: actionTypes.OPEN_YOUNG_INTERVENERS_EXCLUDE_INTERVENER,
    payload: {
        index
    }
});

const requestAccountIntervenersSuccess = (accountId, data = []) => ({
    type: actionTypes.OPEN_YOUNG_INTERVENERS_GET_SUCCESS,
    payload: {
        accountId,
        intervenersList: data
    }
});

const requestAccountIntervenersFailure = (error) => ({
    type: actionTypes.OPEN_YOUNG_INTERVENERS_GET_FAILURE,
    payload: {
        error
    }
});

const requestInterveners = accountId => ({
    type: actionTypes.OPEN_YOUNG_INTERVENERS_GET_REQUEST,
    payload: {
        accountId
    }
});

const requestAccountInterveners = (accountId) => (dispatch, getState) => {
    const immAccount = getState().accounts.getIn(['byId', accountId]);
    const accountsRequestData = {
        query: {
            producto: immAccount.get('product'),
            numeroContrato: immAccount.get('contractNumber'),
        }
    };

    dispatch(requestInterveners(accountId));

    return APIGet({
        dispatch,
        endpoint: 'hiringInterveners',
        params: accountsRequestData
    })
    .then(response => dispatch(requestAccountIntervenersSuccess(accountId, response.dato)))
    .catch(response => {
        if (!!response.error) {
            dispatch(requestAccountIntervenersFailure(response.error.description));
        } else {
            throw response;
        }
    });
};

const resetAccountInterveners = () => ({
    type: actionTypes.OPEN_YOUNG_INTERVENERS_RESTORE_DEFAULT_INTERVENERS,
});

const validateStep = () => ({
    type: actionTypes.OPEN_YOUNG_INTERVENERS_VALIDATE_STEP,
});

module.exports = {
    changeIntervenerRelationship,
    excludeIntervener,
    requestAccountInterveners,
    reset,
    resetAccountInterveners,
    validateStep,
};
